import { Button, Stack } from "@mui/material";
import {
  COLOR_BLACK,
  COLOR_LESS_BLACK,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
  GRADIENT_GRAY,
  GRADIENT_HOVER,
  GRADIENT_MAIN,
} from "../../../data/colors/Colors";
import { ReactElement } from "react";
import React from "react";
import { CustomTextView } from "../../component/CustomTextView";
import { useLocation, useNavigate } from "react-router-dom";

export interface DrawerItem {
  isRoute: boolean;
  title: string;
  icon: ReactElement;
  selectedIcon?: ReactElement;
  onClick?: () => void;
  isSelected?: boolean;
  href?: string;
  onCloseDrawer?: () => void;
}

export function DrawerItemView(props: DrawerItem) {
  const navigate = useNavigate();
  const location = useLocation();

  const bgColor = props.isRoute
    ? props.isSelected
      ? GRADIENT_MAIN
      : GRADIENT_GRAY
    : COLOR_WHITE;
  return (
    <Button
      key={props.title}
      sx={{
        background: bgColor,
        paddingTop: props.isRoute ? 1.75 : 1.25,
        paddingBottom: props.isRoute ? 1.75 : 1.25,
        paddingLeft: 3,
        paddingRight: 3,
        marginLeft: 2,
        marginTop: 1,
        marginRight: 2,
        borderRadius: props.isRoute ? 4 : 44,
        border: "1px solid lightGray",
        "&:hover": {
          background: props.isRoute ? GRADIENT_HOVER : COLOR_VERY_LIGHT_GRAY,
          "@media (hover: none)": {
            background: bgColor,
          },
        },
        "& .MuiTouchRipple-child": {
          backgroundColor: COLOR_LESS_BLACK,
        },
      }}
      onClick={
        props.isRoute
          ? () => {
              if (location.pathname === props.href) return;
              navigate(props.href!);
              window.scrollTo(0, 0);
              setTimeout(() => {
                if (props.onCloseDrawer != undefined) props.onCloseDrawer();
              }, 300);
            }
          : props.onClick
      }
      LinkComponent={"a"}
    >
      <Stack
        direction={"row"}
        spacing={props.isRoute ? 1 : 0.5}
        justifyContent={props.isRoute ? "start" : "center"}
        alignItems={"center"}
        display={"flex"}
        flex={1}
      >
        {React.Children.map(
          props.isSelected ? props.selectedIcon! : props.icon,
          (child) => {
            return React.cloneElement(child as ReactElement<any>, {
              sx: {
                color: props.isRoute
                  ? props.isSelected
                    ? COLOR_WHITE
                    : COLOR_BLACK
                  : COLOR_LESS_BLACK,
              },
            });
          },
        )}
        <CustomTextView
          text={props.title}
          textColor={
            props.isRoute
              ? props.isSelected
                ? COLOR_WHITE
                : COLOR_BLACK
              : COLOR_LESS_BLACK
          }
          props={{ textTransform: "none" }}
          fontWeight={
            props.isRoute ? (props.isSelected ? "bold" : "normal") : "normal"
          }
        />
      </Stack>
    </Button>
  );
}
